import { Link, useRouteError } from "react-router-dom";
import { createStyles, Title, Text, Button, Container, Group, Center, Box } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  label: {
    textAlign: "center",
    fontWeight: 900,
    fontSize: 220,
    lineHeight: 1,
    marginBottom: theme.spacing.xl * 1.5,
    color: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.brand[6],

    [theme.fn.smallerThan("sm")]: {
      fontSize: 120,
    },
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    textAlign: "center",
    fontWeight: 900,
    fontSize: 38,

    [theme.fn.smallerThan("sm")]: {
      fontSize: 32,
    },
  },

  description: {
    maxWidth: 500,
    margin: "auto",
    marginTop: theme.spacing.xl,
    marginBottom: theme.spacing.xl * 1.5,
  },
}));

export default function Error() {
  const { classes } = useStyles();
  const error = useRouteError();
  console.error(error);

  return (
    <Container>
      <Center h={window.innerHeight}>
        <Box>
          <Title className={classes.label}>{error.status}</Title>
          <Title className={classes.title}>이런, 문제가 발생했습니다</Title>
          <Text color="dimmed" size="lg" align="center" className={classes.description}>
            {error.statusText || error.message}
          </Text>
          <Group position="center">
            <Button
              variant="subtle"
              size="md"
              onClick={() => {
                // go to '/' and force reload
                window.location.href = "/";
              }}
            >
              메인으로 돌아가기
            </Button>
          </Group>
        </Box>
      </Center>
    </Container>
  );
}
